module.exports = __webpack_public_path__ + "91cb647723ec27661c12c835eb63dca0.fbx";